import { useState } from "react";
import MomSysDirectShipDetailCreateDialog from "../dialogTypes/MomSysDirectShipDetailCreateDialog";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function MomSysDirectShipDetailCreateButton(props) {
    const { id, refresh, schema, onSelectMst, onSuccess, ...others } = props;
    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onApiSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} {...others} />
            <MomSysDirectShipDetailCreateDialog
                id={id + "create-dialog"}
                schema={schema}
                onSelectMst={onSelectMst}
                open={open}
                onClose={onClose}
                onSuccess={onApiSuccess}
            />
        </>
    );
}

export default MomSysDirectShipDetailCreateButton;
